<template>
  <!-- Modal -->
  <div
    :id="modalHtmlId"
    class="modal fade modal-fade-in-scale-up"
    aria-hidden="false"
    aria-labelledby="modalHtmlId"
    role="dialog"
    tabindex="-1">
    <div class="modal-dialog modal-simple">
      <user-form
        :editable="editable"
        :modalHtmlId="modalHtmlId"
        @submit="submit"
        @verificationSubmit="verificationSubmit"
        ref="userform"/>
    </div>
  </div>
  <!-- End Modal -->
</template>

<script>
import UserForm from './UserForm'
import Qs       from 'query-string'
import { http } from '@/http'

export default {
  components: {
    UserForm
  },
  data () {
    return {
      editable:    true,
      modalHtmlId: ''
    }
  },
  methods:    {
    verificationSubmit (data) {
      data = Qs.stringify(data)
      http.post(
        `User/createWithVerification`,
        data,
        {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        }
      )
        /* zpracovani pozadavku */
          .then(response => {
            this.$emit('refresh')
            $('#' + this.modalHtmlId).modal('hide')
          })

          .catch(e => {
            console.error(e)
          })
    },
    submit (data) {
      data = Qs.stringify(data)
      http.post(
        `User/create`,
        data,
        {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        }
      )
        /* zpracovani pozadavku */
          .then(response => {
            this.$emit('refresh')
            $('#' + this.modalHtmlId).modal('hide')
          })

          .catch(e => {
            console.error(e)
          })
    }
  },
  mounted () {
    this.modalHtmlId = 'addUserModal'
  },
  updated () {
    let module = this

    $('#' + this.modalHtmlId).on('hidden.bs.modal', function () {
      module.$refs.userform.resetForm()
    })
  }
}
</script>
